import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, inject, onMounted } from "vue";

import { assert_not_null, generate_uid } from "@/utils";

interface PropTypes {
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'context_menu_item',
  props: {
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any, { emit }: { emit: ({
  click: [];
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean };

const id = `context-menu-item-${generate_uid()}`;





const register =
  inject<
    (id: string, update_item_activated_with_keyboard: () => unknown) => unknown
  >("register");
onMounted(() => {
  assert_not_null(register);
  register(id, () => {
    assert_not_null(active_descendent_id);
    if (active_descendent_id.value === id && !props.disabled) {
      emit("click");
    }
  });
});
const active_descendent_id = inject<ComputedRef<string>>(
  "active_descendent_id",
);

return { __sfc: true,id, props, emit, register, active_descendent_id }
}

})